import { render } from "./FooterView.vue?vue&type=template&id=762886a2"
const script = {}

import "./FooterView.vue?vue&type=style&index=0&id=762886a2&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__